<template>
  <b-modal
    centered
    dialog-class="view-task-modal"
    hide-footer
    :visible="value"
    size="lg"
    hide-header
    @change="onVisibilityChange"
  >
    <view-task
      @task-deleted="onTaskDeleted"
      @task-archived="onTaskArchived"
      :paBreadcrumb="paBreadcrumb"
      :customerBreadcrumb="customerBreadcrumb"
      :modalTaskId="taskId"
      @task-handover="onTaskHandover"
      @timer-started="onTimerStarted"
      @timer-stopped="onTimerStopped"
      @status-updated="onStatusUpdated"
      @priority-changed="onPriorityChanged"
      :isPopupMode="true"
      :queueName="queueName"
      @navigate="onNavigate"
    />
  </b-modal>
</template>
<script>
import ViewTask from "@/views/common/ViewTask";
export default {
  props: {
    value: {
      type: [String, Boolean]
    },
    taskId: {
      type: String
    },
    paBreadcrumb: {
      type: Boolean,
      default: false
    },
    customerBreadcrumb: {
      type: Boolean,
      default: false
    },
    queueName: {
      type: String
    }
  },
  components: {
    ViewTask
  },
  methods: {
    onVisibilityChange(isVisible) {
      this.$emit("input", isVisible);
    },
    onTaskDeleted() {
      // close the modal
      this.$emit('task-deleted')
      this.onVisibilityChange(false);
    },
    onTaskArchived() {
      // close the modal
      this.$emit("task-archived");
      this.onVisibilityChange(false);
    },
    onTaskHandover() {
      this.$emit('task-handover')
      this.onVisibilityChange(false);
    },
    onTimerStarted() {
      this.$emit('timer-started')
    },
    onTimerStopped() {
      this.$emit('timer-stopped')
    },
    onStatusUpdated() {
      this.$emit('status-updated')
    },
    onNavigate() {
      this.$emit('navigate')
    },
    onPriorityChanged(data) {
      this.$emit('priority-changed', data);
    }
  }
};
</script>
<style scoped lang="scss">
@import "~@/scss/variables/colors.scss";

$rounded-radius: 6px;
::v-deep .fade {
  transition: none !important;
}
::v-deep .view-task-modal {
  transition: none !important;
}
::v-deep .view-task-modal {
  max-width: 85vw;
  .modal-content {
      border-radius: $rounded-radius;
    }
  .modal-body {
    border-radius: $rounded-radius;
    padding: 0;
  }
  .add-task-container {
    border-radius: $rounded-radius;
    padding: 0;
    position: relative;
    left: 0rem;
    top: 0rem;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    > div {
      > span {
        padding: 0px;
      }
    }
    .breadcrumb {
      padding: 0 0 20px 0 !important;
      .breadcrumb-item,
      .breadcrumb-item::before,
      .breadcrumb-item span {
        line-height: normal;
      }
    }
    .main-column {
      background: $bg--light;
      flex: 0 0 70%;
      max-width: 70%;
      padding-top: 20px;
      padding-left: 20px;
    }
    .tasks-right-container {
      flex: 0 0 30%;
      max-width: 30%;
      width: 30%;
      position: relative;
      right: 0;
      z-index: 2;
      display: flex;
      padding: 55px 0 0 0;
      top: 0rem;
      background: #fff;
      height: 100vh;
      overflow-y: auto;

      > div:nth-child(1) {
        order: 2;
      }
      > div.info-wrapper.first-div {
        padding-top: 0;
        order: 0;
      }
      > div:nth-child(2) {
        order: 1;
      }
      > div:nth-child(3) {
        order: 3;
      }
    }
    .delete-button-row {
      display: flex;
      margin: 0;
      padding: 0;
      button {
        margin-left: 20px;
      }
      > div:nth-child(1) {
        flex: 7;
        background: $bg--light;
      }
      > div:nth-child(2) {
        flex: 3;
      }
    }
    @media (max-width: 1199px) {
      .main-column {
        flex: 0 0 100%;
        max-width: 100%;
      }
    }
  }
}
</style>
